import { PayloadAction } from "@reduxjs/toolkit";

import { IState } from "../types/state";

const setUser = (state: IState, action: PayloadAction<IState['user']['data']>) => {
  state.user.data = action.payload;
};

export default setUser;
